import { render, staticRenderFns } from "./CommodityParamsSelect.vue?vue&type=template&id=2df65b24&"
import script from "./CommodityParamsSelect.vue?vue&type=script&lang=js&"
export * from "./CommodityParamsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports